import styled from 'styled-components';

import profileAvatarImage from '../../../assets/images/profile-avatar-default.png';
import profilePhotoImage from '../../../assets/images/registration-complete-avatar-photo.png';
import { resolveRenderableAvatarUrl } from '../../../shared/model';

type RegistrationCompletePreviewVariant = 'with-photo' | 'without-photo';

type RegistrationCompleteProfileAvatarProps = {
  avatarUrl?: string | null;
  previewVariant: RegistrationCompletePreviewVariant;
  sizePx?: number;
};

const AvatarFrame = styled.div<{ $sizePx: number }>`
  width: ${({ $sizePx, theme }) => theme.scale.px($sizePx)};
  height: ${({ $sizePx, theme }) => theme.scale.px($sizePx)};
  border-radius: 50%;
  overflow: hidden;
  background: #d9e6ff;
  position: relative;
`;

const AvatarPhoto = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
`;

export function RegistrationCompleteProfileAvatar({
  avatarUrl = null,
  previewVariant,
  sizePx = 49,
}: RegistrationCompleteProfileAvatarProps) {
  const photoSource =
    previewVariant === 'with-photo'
      ? resolveRenderableAvatarUrl(avatarUrl)
      : null;

  return (
    <AvatarFrame $sizePx={sizePx}>
      {photoSource ? (
        <AvatarPhoto alt="" aria-hidden src={photoSource} />
      ) : previewVariant === 'with-photo' ? (
        <AvatarPhoto alt="" aria-hidden src={profilePhotoImage} />
      ) : (
        <AvatarPhoto alt="" aria-hidden src={profileAvatarImage} />
      )}
    </AvatarFrame>
  );
}
